import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'
import axios from 'axios'
const ENV = require('../config/dev.env')

Vue.use(Vuex);

const defaultState = {
    gallery: [],
    selectedImage: {
        image: {},
        position: "",
        pagination: [],
    },
    currentPath: "",
    payload: {
        country: 'Please Choose One',
        code: []
    }
}

export const store = new Vuex.Store({
    state: {...defaultState},
    mutations: {
        setGallery(state,arr) {
            state.gallery = arr.map( (item,index) => {
                return {...item, pos:index, }
            } )
        },
        setSelectedImage(state,obj) {
            state.selectedImage.image = obj[0]
            state.selectedImage.position = obj[1]
            state.selectedImage.pagination = [
                (state.selectedImage.position - 1) != -1 ? state.gallery[state.selectedImage.position - 1] : false,
                (state.selectedImage.position + 1) < state.gallery.length ? state.gallery[state.selectedImage.position + 1] : false
            ]

            //TODO remove before launch
        },
        setCurrentPath(state,str) {
            window.localStorage.setItem("currentPath", str)
            state.currentPath = str
        }
    },
    actions: {
        updateGallery({commit},arr) {
            commit('setGallery',arr)
        },
        updateSelectedImage({commit},obj) {
            commit('setSelectedImage',obj)
        },
        updateCurrentPath({commit},str) {
            commit('setCurrentPath',str)
        }
        
    }

})



// WEBPACK FOOTER //
// ./src/store.js